import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  private readonly SUPPORT_ZENDESK_ID = 'support-zendesk';
  private readonly STATUSES = {
    SHOWN: {
      id: 'SHOWN',
      action: (service: SupportService) => {
        service.show();
      }
    },
    HIIDEN: {
      id: 'HIIDEN',
      action: (service: SupportService) => {
        service.hide(true);
      }
    }
  };

  load(): void {
    window.addEventListener('load', () => {
      // load styles
      const status = localStorage.getItem(this.SUPPORT_ZENDESK_ID);
      if (status) {
        this.STATUSES[status].action(this);
        return;
      }
    });
  }

  unload(): void {
    if (!this.isLoaded()) {
      this.hide(true);
      return;
    }

    // remove the script tag from the DOM
    const head = document.head as HTMLDivElement;
    const script = document.getElementById('ze-snippet');
    head.removeChild(script);

    this.hide(true);
  }

  hide(save: boolean): void {
    if (this.isStylesLoaded()) {
      return;
    }

    const head = document.head as HTMLDivElement;
    const style = document.createElement('style');
    style.id = 'launcher-style';
    style.innerHTML = `
      #launcher {
        visibility: hidden;
      }
    `;
    head.appendChild(style);

    if (save) {
      localStorage.setItem(this.SUPPORT_ZENDESK_ID, this.STATUSES.HIIDEN.id);
    }
    document.getElementById('freshworks-container').style.display = 'none';
  }

  show(): void {
    const head = document.head as HTMLDivElement;
    const style = document.getElementById('launcher-style');
    if (!style) {
      return;
    }

    head.removeChild(style);

    // save status
    localStorage.setItem(this.SUPPORT_ZENDESK_ID, this.STATUSES.SHOWN.id);

    document.getElementById('freshworks-container').style.display = 'block';
  }

  toggle(): void {
    if (this.isStylesLoaded()) {
      this.show();
    } else {
      this.hide(true);
    }
  }

  isStylesLoaded(): boolean {
    return document.getElementById('launcher-style') !== null;
  }

  isLoaded(): boolean {
    return document.getElementById('ze-snippet') !== null;
  }
}
